export interface AddJournalEntryForm {
  entryText: string;
  style?: string;
}
